export const SET_TRADE_IDEAS = "SET_TRADE_IDEAS";
export const SET_HISTORY_TRADE_IDEAS = "SET_HISTORY_TRADE_IDEAS";

export const SET_RESET_TRADE_IDEAS = "SET_RESET_TRADE_IDEAS";
export const SET_RESET_HISTORY_TRADE_IDEAS = "SET_RESET_HISTORY_TRADE_IDEAS";

export const SET_LOADING = "SET_LOADING";
